import { CheckOutlined } from "@ant-design/icons";
import { DialogContent } from "api/dialog";
import { Badge } from "../Interactive/components/Badge";
import FileIcon from "resources/FileIcon.svg";
import i18n from "i18next";

export type ContentBlockComponent = (props: {
  mobile?: boolean;
  className?: string;
}) => JSX.Element;

const Content = (block: DialogContent): ContentBlockComponent => {
  switch (block.type) {
    case "file":
      return () => (
        <>
          {block.link && (
            <a href={block.link} target="_blank" rel="noreferrer">
              <Badge
                icon={FileIcon}
                name={block.name ?? i18n.t("widget.defaultFileName")}
                subtitle={block.size}
              />
            </a>
          )}
          {!block.link && (
            <Badge
              icon={FileIcon}
              name={i18n.t("widget.noFileLink")}
              subtitle={block.size}
            />
          )}
        </>
      );
    case "text":
      return ({ className }) => (
        <>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              rowGap: 8,
            }}
          >
            {block.attached?.[0].type === "photo" && (
              <img src={block.attached[0].link} alt="dialog content" />
            )}
            {block.html && (
              <span
                className={className}
                style={{ whiteSpace: "pre-wrap" }}
                dangerouslySetInnerHTML={{ __html: block.text }}
              />
            )}
            {!block.html && (
              <span className={className} style={{ whiteSpace: "pre-wrap" }}>
                {block.text}
              </span>
            )}
          </div>
          {block.checked && (
            <CheckOutlined
              style={{
                marginLeft: "auto",
                paddingLeft: "10px",
                marginTop: "auto",
              }}
            />
          )}
        </>
      );
    case "photo":
      return ({ className }) => (
        <img
          className={className}
          src={block.link}
          alt="dialog content"
          style={{ backgroundSize: "contain", width: "100%" }}
        />
      );
    case "video":
      return ({ className }) => (
        <video controls className={className} src={block.link}>
          Your browser does not support
          <code>video</code> playback.
        </video>
      );
    case "audio":
      return ({ className }) => (
        <audio controls src={block.link}>
          Your browser does not support
          <code>audio</code> playback.
        </audio>
      );
  }
};

export default Content;
